import { useEffect } from 'react';

const DEFAULT_THEME = {
  primaryColor: '#159f91',
  fontPrimaryColor: '#FFFFFF',
  headerFooterColor: '#07111e',
  fontHeaderFooterColor: '#e9f2fb',
};

const applyTheme = (theme = {}) => {
  const root = document.documentElement;
  root.style.setProperty('--primary-color', theme.primaryColor || DEFAULT_THEME.primaryColor);
  root.style.setProperty('--primary-font-color', theme.fontPrimaryColor || DEFAULT_THEME.fontPrimaryColor);
  root.style.setProperty('--header-footer-bg', theme.headerFooterColor || DEFAULT_THEME.headerFooterColor);
  root.style.setProperty('--header-footer-font', theme.fontHeaderFooterColor || DEFAULT_THEME.fontHeaderFooterColor);
};

/**
 * ThemeProvider - Aplica los colores personalizados del cliente al backoffice
 * Los colores se obtienen de la configuración de la empresa y se aplican como CSS variables
 */
const ThemeProvider = ({ children }) => {
  useEffect(() => {
    // No cargar tema aquí - el Header se encarga de eso
    // Solo establecer valores por defecto iniciales
    applyTheme(DEFAULT_THEME);

    // Escuchar evento personalizado para actualizar el tema
    const handleThemeUpdate = (event) => {
      applyTheme(event.detail || DEFAULT_THEME);
    };
    
    window.addEventListener('themeUpdated', handleThemeUpdate);
    
    return () => {
      window.removeEventListener('themeUpdated', handleThemeUpdate);
    };
  }, []);

  return children;
};

export default ThemeProvider;

